import { ROUTES } from '@celito.clients/enums';
import { checkIfPublicRoute } from '@celito.clients/utils';
import React from 'react';
import { Route, Routes } from 'react-router';

import Main from '../screens/main/main.screen';
import { TenantManagementAccess } from '../screens/Platform/tenant-management/components/tenant-management-access';
import PlatformRoutes from './platform-routes';
import ProtectedRoutes from './protected-routes';
import PublicRoutes from './public-routes';
import { TenantAccessGuard } from './tenant-access-guard';

const RouteConfig: React.FC = () => {
  const isPublicRoute = checkIfPublicRoute();

  return (
    <Routes>
      <Route index element={<Main />} />
      {isPublicRoute ? (
        <Route path={`${ROUTES.MAIN}*`} element={<PublicRoutes />} />
      ) : (
        <>
          <Route element={<TenantManagementAccess />}>
            <Route
              path={`${ROUTES.TENANT_MANAGEMENT}/*`}
              element={<PlatformRoutes />}
            />
          </Route>
          <Route element={<TenantAccessGuard />}>
            <Route path={`${ROUTES.MAIN}*`} element={<ProtectedRoutes />} />
          </Route>
        </>
      )}
    </Routes>
  );
};

export default RouteConfig;
